<div class="row justify-content-center" [ngClass]="routeAnimationsElements">
  <div>
    <mat-stepper linear #stepper>
      <!-- <mat-step [stepControl]="firstFormGroup"> -->
      <!-- <form [formGroup]="firstFormGroup"> -->
      <mat-step [stepControl]="firstFormGroup">
        <div *ngIf="(isLoading$ | async)" class="loading-indicator">
          <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
        </div>
        <form [formGroup]="firstFormGroup" *ngIf="!(isLoading$ | async)">
          <ng-template matStepLabel>Datos de la empresa</ng-template>

          <h2 class="secondary-header">
            Datos de la empresa
          </h2>

          <div class="company-data" *ngIf="this.formInputPF.action != 'Update' && this.formInputPJ.action != 'Update'">
            <div class="company-type">
              <span>Seleccionar el tipo: </span>
              <div class="row mb-1">
                <mat-radio-group aria-label="" [value]="tipoPersonaEmpresa" required
                  (change)="handleChangeTipoPersona($event)">
                  <mat-radio-button value="persona_juridica" [checked]="true"> Empresa - Persona jurídica
                  </mat-radio-button>
                  <mat-radio-button value="persona_fisica"> Persona </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>

          <div [hidden]="getTipoPersonaEmpresa()!=='persona_juridica'" class="row justify-content-center">
            <rpe-persona-juridica-form #personaJuridicaFormComponent [formInput]="formInputPJ"
              (formValueChangesRPEPJ)="formValueChangesRPEPJ($event)" (formStatusChanges)="formStatusChangesPJ($event)"
              (onRutStatusChange)="rutStatusChange($event)" (onDGILoadedChange)="onDGILoadedChange($event)">
            </rpe-persona-juridica-form>
          </div>

          <div [hidden]="getTipoPersonaEmpresa()!=='persona_fisica'">
            <p><b>Sólo para criadero</b></p>
            <rpe-persona-fisica-form [formInput]="formInputPF" #personaFisicaFormComponent
              (formValueChangesRPEPF)="formValueChangesRPEPF($event)" (formStatusChanges)="formStatusChangesPF($event)">
            </rpe-persona-fisica-form>
          </div>

          <div class="actions" *ngIf="shouldShowActions()">
            <button type="button" mat-raised-button (click)="volver()" *ngIf="shouldShowVolverButton()">
              {{ 'rpe.vista-usuario.volver' | translate }}
            </button>
            <button type="button" routerLink="/main/landing" mat-raised-button *ngIf="shouldShowCancelButton()">
              {{ 'rpe.vista-usuario.cancelar' | translate }}
            </button>
            <button type="button" mat-raised-button (click)="onSubmit()" color="primary">
              {{ 'rpe.vista-usuario.confirmar' | translate }}
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="secondFormGroup" *ngIf="getTipoPersonaEmpresa() !== 'persona_fisica'">
        <div *ngIf="(isLoading$ | async)" class="loading-indicator">
          <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
        </div>
        <form [formGroup]="secondFormGroup" *ngIf="!(isLoading$ | async)">
          <ng-template matStepLabel>Depósitos y dependencias</ng-template>
          <div class="company-data" *ngIf="showCards">
            <div class="company-type">
              <span>Actividades vinculadas exclusivamente a la comercialización</span>
              <div class="row mb-1">
                <mat-radio-group aria-label="" required (change)="onUnicamenteComercializacion($event)">
                  <mat-radio-button [checked]="unicamenteComercializacion" [value]="true"> Sí </mat-radio-button>
                  <mat-radio-button [checked]="(unicamenteComercializacion != null) && !unicamenteComercializacion"
                    [value]="false"> No </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
          <ng-container *ngIf="unicamenteComercializacion != null">
            <div class="otras-actividades" *ngIf="showCards && !unicamenteComercializacion">
              <h4 class="secondary-header secondary-header-boder">Otras actividades</h4>
              <mat-checkbox [checked]="comercializacion"
                (change)="onComercializacion($event.checked)">Comercialización</mat-checkbox>
            </div>
            <div class="infra-grid">
              <div *ngIf="showCards && !unicamenteComercializacion">
                <div class="infra-icon">
                  <img src="./assets/iconos/icono-laboratorio.png" alt="">
                  <button mat-raised-button color="primary" (click)="showCards = !showCards; showLab = !showLab">{{
                    laboratorios.length ? 'Agregar/editar laboratorios' : 'Agregar laboratorios'
                    }}</button>
                </div>
              </div>
              <div *ngIf="showCards && !unicamenteComercializacion">
                <div class="infra-icon">
                  <img src="./assets/iconos/procesamiento.jpg" alt="">
                  <button mat-raised-button color="primary"
                    (click)="showCards = !showCards; showSitioProcesamiento = !showSitioProcesamiento ">{{
                    sitiosProcesamiento.length ? 'Agregar/editar sitios de procesamiento' : 'Agregar sitios de
                    procesamiento'
                    }}</button>
                </div>
              </div>
              <div *ngIf="showCards">
                <div class="infra-icon">
                  <img src="./assets/iconos/almacenamiento.png" alt="">
                  <button mat-raised-button color="primary"
                    (click)="showCards = !showCards; showDeposito = !showDeposito ">{{
                    depositos.length ? 'Agregar/editar depósitos' : 'Agregar depósitos'
                    }}</button>
                </div>
              </div>
              <div *ngIf="showCards">
                <div class="infra-icon">
                  <img src="./assets/iconos/vivero.png" alt="">
                  <button mat-raised-button color="primary"
                    (click)="showCards = !showCards; showVivero = !showVivero ">{{
                    formInputViveros.length ? 'Agregar/editar viveros' : 'Agregar viveros'
                    }}</button>
                </div>
              </div>
            </div>
            <div *ngIf="showLab">
              <rpe-registro-actividad-laboratorio-tabs-form [actividadLaboratorioTabsInput]="labsInput"
                (showLabEvent)="showLab = $event; showCards = !showCards"></rpe-registro-actividad-laboratorio-tabs-form>
            </div>
            <div *ngIf="showSitioProcesamiento">
              <rpe-registro-actividad-sitios-procesamiento-tabs-form
                [actividadesSitioProcesamientoTabsInput]="sitiosYMaquinas"
                (showSPEvent)="showSitioProcesamiento = $event; showCards = !showCards"></rpe-registro-actividad-sitios-procesamiento-tabs-form>
            </div>
            <div *ngIf="showDeposito">
              <rpe-registro-actividad-almacenamiento-tabs [actividadDepositoInput]="depositosYDependencias"
                (showDepositoEvent)="showDeposito = $event; showCards = !showCards"></rpe-registro-actividad-almacenamiento-tabs>
            </div>
            <div *ngIf="showVivero">
              <rpe-registro-actividad-viveros-form [actividadViverosFormInput]="viverosInput"
                (showEvent)="showVivero = $event; showCards = !showCards"></rpe-registro-actividad-viveros-form>
            </div>
          </ng-container>

          <div class="action-siguiente">
            <span class="span-align" *ngIf="showCards && unicamenteComercializacion != null">Si no se desarolla ninguna
              de estas
              actividades, continuar el
              trámite.</span>
            <button mat-raised-button color="primary"
              *ngIf="!showLab && !showSitioProcesamiento && !showVivero && !showDeposito && showCards && unicamenteComercializacion != null"
              (click)="onChangeLabStep()">Siguiente</button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="thirdFormGroup">
        <div *ngIf="(isLoading$ | async)" class="loading-indicator">
          <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
        </div>
        <form [formGroup]="thirdFormGroup" *ngIf="!(isLoading$ | async)">
          <ng-template matStepLabel>Integrantes</ng-template>
          <div class="integrantes-info">
            <mat-icon>
              info
            </mat-icon>
            <span><b>Registrar los/las integrantes de la empresa.</b><br>
              Para las actividades: experimentación / criadero / producción / procesamiento para terceros / importación,
              registrar un/a Técnico/a Responsable.<br>
              Para la actividad de laboratorio, registrar un/a Técnico/a Responsable y al menos un/a Analista de
              Laboratorio.</span>

          </div>
          <div class="add-button" *ngIf="!showIntegrantes">
            <button mat-raised-button color="primary" (click)="showIntegrantes = !showIntegrantes">Agregar
              integrante</button>
          </div>
          <div class="integrantes-grid">
            <ng-container *ngFor="let integrante of integrantes">
              <div *ngIf="!showIntegrantes">
                <div class="infra-icon">
                  <img src="./assets/iconos/criadero_registrante.jpg" alt="">
                  <div class="lab-list">
                    <div class="spans">
                      <div class="nombre-flex">
                        <span class="span-color">Nombre:</span>
                        <span class="span-align">{{integrante.nombre_completo}}</span>
                      </div>
                      <div class="rol-flex">
                        <span class="span-color">Rol:</span>
                        <span class="span-align">
                          {{ findRol(integrante.rol.tipo_rol_id) ?
                          findRol(integrante.rol.tipo_rol_id).nombre : 'No se encontro el rol' }}
                        </span>
                      </div>
                    </div>
                    <div class="options" *ngIf="!integrante.rol.es_creador">
                      <rpe-ui-button [bg_blue]="true" icon="edit" (onClick)="updateIntegrante(integrante)">Editar
                        Integrante</rpe-ui-button>
                      <rpe-ui-button [bg_orange]="true" icon="delete" (onClick)="deleteIntegrante(integrante)">Eliminar
                        Integrante</rpe-ui-button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <div *ngIf="showIntegrantes">
            <rpe-registro-integrante-form [personaJuridica]="createdPersonaJuridica"
              [personaFisica]="createdPersonaFisica" (onCancel)="showIntegrantes = !showIntegrantes"
              [laboratorios]="laboratorios"
              [naturalezasJuridicas]="naturalezasJuridicas"></rpe-registro-integrante-form>
          </div>
        </form>
        <div class="action-next">
          <button mat-raised-button color="primary" *ngIf="!showIntegrantes"
            (click)="onChangeIntegrantesStep()">Siguiente</button>
        </div>
      </mat-step>
      <mat-step [stepControl]="fourthFormGroup">
        <div *ngIf="(isLoading$ | async)" class="loading-indicator">
          <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
        </div>
        <ng-template matStepLabel>Finalizar</ng-template>
        <!-- Denominacion social, naturaleza juridica y rut.  -->
        <div class="flow-info" *ngIf="!(isLoading$ | async)">
          <div class="integrantes-info" *ngIf="hasTecnicoResponsable">
            <mat-icon>
              info
            </mat-icon>
            <span><b>La inscripción en el Registro General de Semilleristas está pendiente de aprobación.</b></span>
          </div>
          <h4 class="secondary-header secondary-header-boder">Datos de la empresa</h4>
          <rpe-datos-mi-empresa-container [matCard]="false" [modificarButtons]="false"></rpe-datos-mi-empresa-container>
          <br>
          <div class="button-finalizar">
            <button mat-raised-button color="primary" (click)="saveRegister()" *ngIf="!hideRegisterButton"
              [disabled]="entidadesProductivasIsLoading$ | async">Finalizar</button>
          </div>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
</div>